import FlickityFade from 'flickity-fade';

const selectors = {
  productSlideshow: '[data-product-slideshow]',
  productThumbs: '[data-product-thumbs]',
  sliderThumb: '[data-thumb-item]',
  dataTallLayout: 'data-tall-layout',
  dataType: 'data-type',
  dataMediaId: 'data-media-id',
  dataThumb: 'data-thumb',
  dataThumbIndex: 'data-thumb-index',
  ariaLabel: 'aria-label',
  dataThumbnail: '[data-thumbnail]',
  productSlideThumb: '.js-product-slide-thumb',
  classSelected: 'is-active',
  classMediaHidden: 'media--hidden',
  sliderEnabled: 'flickity-enabled',
  focusEnabled: 'is-focused',
  thumbsSlider: '[data-thumbs-slider]',
};

const thumbIcons = {
  model:
    '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-media-model" viewBox="0 0 26 26"><path d="M1 25h24V1H1z"/><path class="icon-media-model-outline" d="M.5 25v.5h25V.5H.5z" fill="none"/><path class="icon-media-model-element" d="M19.13 8.28L14 5.32a2 2 0 0 0-2 0l-5.12 3a2 2 0 0 0-1 1.76V16a2 2 0 0 0 1 1.76l5.12 3a2 2 0 0 0 2 0l5.12-3a2 2 0 0 0 1-1.76v-6a2 2 0 0 0-.99-1.72zm-6.4 11.1l-5.12-3a.53.53 0 0 1-.26-.38v-6a.53.53 0 0 1 .27-.46l5.12-3a.53.53 0 0 1 .53 0l5.12 3-4.72 2.68a1.33 1.33 0 0 0-.67 1.2v6a.53.53 0 0 1-.26 0z" opacity=".6" style="isolation:isolate"/></svg>',
  video:
    '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-media-video" viewBox="0 0 26 26"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 25h24V1H1v24z"/><path class="icon-media-video-outline" d="M.5 25v.5h25V.5H.5V25z"/><path class="icon-media-video-element" fill-rule="evenodd" clip-rule="evenodd" d="M9.718 6.72a1 1 0 0 0-1.518.855v10.736a1 1 0 0 0 1.562.827l8.35-5.677a1 1 0 0 0-.044-1.682l-8.35-5.06z" opacity=".6"/></svg>',
};

class InitSlider {
  constructor(section) {
    this.container = section.container;
    this.tallLayout = this.container.getAttribute(selectors.dataTallLayout) === 'true';
    this.slideshow = this.container.querySelector(selectors.productSlideshow);
    this.thumbs = this.container.querySelector(selectors.productThumbs);
    this.mobileSliderEnable = this.container.getAttribute(selectors.mobileSliderEnable) === 'true';

    this.flkty = null;
    this.flktyThumbs = null;
    this.thumbsSlider = null;

    this.init();
  }

  init() {
    if (this.tallLayout) {
      this.initSliderMobile();

      document.addEventListener('theme:resize', () => {
        this.initSliderMobile();
      });
    } else {
      this.createSlider();
    }
  }

  initSliderMobile() {
    const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const isMobile = windowWidth < theme.sizes.small;
    if (isMobile) {
      this.createSlider();
    } else {
      this.destroySlider();
    }
  }

  destroySlider() {
    const isSliderInitialized = this.slideshow.classList.contains(selectors.sliderEnabled);

    if (isSliderInitialized) {
      this.flkty.destroy();
    }

    if (this.thumbs) {
      this.thumbs.innerHTML = '';
    }

    if (this.flktyThumbs !== null) {
      this.flktyThumbs.destroy();
      this.flktyThumbs = null;
    }
  }

  createSlider() {
    if (!this.slideshow) {
      return;
    }

    const instance = this;
    const firstSlide = this.slideshow.querySelectorAll(`[${selectors.dataType}]`)[0];

    let flickityOptions = {
      autoPlay: false,
      prevNextButtons: false,
      contain: true,
      pageDots: false,
      adaptiveHeight: true,
      wrapAround: true,
      fade: true,
      on: {
        ready: function () {
          instance.sliderThumbs(this);
        },
      },
    };

    this.flkty = new FlickityFade(this.slideshow, flickityOptions);
    this.flkty.resize();

    if (firstSlide) {
      const firstType = firstSlide.getAttribute(selectors.dataType);

      if (firstType === 'model' || firstType === 'video' || firstType === 'external_video') {
        this.flkty.options.draggable = false;
        this.flkty.updateDraggable();
      }
    }

    this.flkty.on('change', function (index) {
      let lastSLideIdx = index;

      if (instance.thumbs) {
        const selectedElem = instance.thumbs.querySelector(`.${selectors.classSelected}`);
        const currentSlide = instance.thumbs.querySelector(`${selectors.sliderThumb} [${selectors.dataThumbIndex}="${index}"]`);

        if (selectedElem) {
          lastSLideIdx = Array.from(selectedElem.parentElement.children).indexOf(selectedElem);
          selectedElem.classList.remove(selectors.classSelected);
        }

        if (currentSlide) {
          currentSlide.parentElement.classList.add(selectors.classSelected);
        }
      }

      const currentMedia = this.cells[lastSLideIdx].element;
      const newMedia = this.selectedElement;

      currentMedia.dispatchEvent(new CustomEvent('mediaHidden'));
      newMedia.classList.remove(selectors.classMediaHidden);
    });

    this.flkty.on('settle', function () {
      const currentMedia = this.selectedElement;
      const otherMedia = Array.prototype.filter.call(currentMedia.parentNode.children, function (child) {
        return child !== currentMedia;
      });
      const mediaType = currentMedia.getAttribute(selectors.dataType);
      const isFocusEnabled = document.body.classList.contains(selectors.focusEnabled);

      if (mediaType === 'model' || mediaType === 'video' || mediaType === 'external_video') {
        // fisrt boolean sets value, second option false to prevent refresh
        instance.flkty.options.draggable = false;
        instance.flkty.updateDraggable();
      } else {
        instance.flkty.options.draggable = true;
        instance.flkty.updateDraggable();
      }

      if (isFocusEnabled) currentMedia.dispatchEvent(new Event('focus'));

      if (otherMedia.length) {
        otherMedia.forEach((element) => {
          element.classList.add(selectors.classMediaHidden);
        });
      }

      currentMedia.dispatchEvent(new CustomEvent('mediaVisible'));
    });

    instance.container.addEventListener('click', function (e) {
      const target = e.target;

      if (target.matches(selectors.productSlideThumb) || target.closest(selectors.productSlideThumb)) {
        e.preventDefault();

        let slideIdx = 0;
        let selector;
        if (target.matches(selectors.productSlideThumb)) {
          selector = target;
        } else {
          selector = target.closest(selectors.productSlideThumb);
        }

        slideIdx = parseInt(selector.getAttribute(selectors.dataThumbIndex));

        instance.flkty.select(slideIdx);
      }
    });
  }

  createThumbSlider() {
    let flickityOptions = {
      autoPlay: false,
      prevNextButtons: false,
      contain: true,
      pageDots: false,
      adaptiveHeight: false,
      wrapAround: false,
      cellAlign: 'left',
    };

    let isMobile = (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) < theme.sizes.small;

    this.thumbsSlider = this.container.querySelector(selectors.thumbsSlider);

    const initSlider = () => {
      this.flktyThumbs = new FlickityFade(this.thumbsSlider, flickityOptions);
      this.flktyThumbs.resize();
    };

    if (isMobile) {
      initSlider();
    }

    document.addEventListener('theme:resize', () => {
      isMobile = (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) < theme.sizes.small;

      if (isMobile) {
        initSlider();
      } else if (this.flktyThumbs !== null) {
        this.flktyThumbs.destroy();
        this.flktyThumbs = null;
      }
    });
  }

  sliderThumbs(thisEl) {
    const slides = thisEl.slides;
    const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    if (this.thumbs && slides.length) {
      let slidesHtml = '';
      slides.forEach((element, i) => {
        const slide = element.cells[0].element;
        const type = slide.getAttribute(selectors.dataType);
        const mediaId = slide.getAttribute(selectors.dataMediaId);
        const thumb = slide.getAttribute(selectors.dataThumb);
        let thumbAlt = '';
        const thumbIcon = thumbIcons[type] ? thumbIcons[type] : '';
        let selected = '';

        if (slide.querySelector(`[${selectors.ariaLabel}]`)) {
          thumbAlt = slide.querySelector(`[${selectors.ariaLabel}]`).getAttribute(selectors.ariaLabel);
        }

        if (thumbAlt === '' && slide.hasAttribute(selectors.ariaLabel)) {
          thumbAlt = slide.getAttribute(selectors.ariaLabel);
        }

        slide.setAttribute('tabindex', '-1');

        if (slide.classList.contains(selectors.classSelected) || i === 0) {
          selected = selectors.classSelected;
        }

        slidesHtml += `<div class="thumb ${selected}" data-thumb-item><a href="${thumb}" class="thumb__link thumb__link--${type} js-product-slide-thumb" data-thumb-index="${i}" data-thumbnail data-media-id="${mediaId}"><img class="thumb__link__image" alt="${thumbAlt}" src="${thumb}">${thumbIcon}</a></div>`;
      });

      if (slidesHtml !== '') {
        slidesHtml = `<div class="thumbs-holder" data-thumbs-slider>${slidesHtml}</div>`;
        this.thumbs.innerHTML = slidesHtml;

        this.createThumbSlider();
      }
    }

    const productThumbImages = this.container.querySelectorAll(selectors.dataThumbnail);
    if (productThumbImages.length) {
      productThumbImages.forEach((element) => {
        element.addEventListener('click', function (e) {
          e.preventDefault();
        });

        element.addEventListener('keyup', function (e) {
          // On keypress Enter move the focus to the first focusable element in the related slide
          if (e.keyCode === 13) {
            const mediaId = this.getAttribute(selectors.dataMediaId);
            const mediaElem = thisEl.element
              .querySelector(`[${selectors.dataMediaId}="${mediaId}"]`)
              .querySelectorAll('model-viewer, video, iframe, button, [href], input, [tabindex]:not([tabindex="-1"])')[0];
            if (mediaElem) {
              mediaElem.dispatchEvent(new Event('focus'));
              mediaElem.dispatchEvent(new Event('select'));
            }
          }
        });
      });
    }
  }
}

export default InitSlider;
